import React from 'react';


function A8Risap() {
    return (
        <div>
            <p>PR: ビジネスの資本である身体に投資をし始めませんか? </p>
            <a href="https://px.a8.net/svt/ejp?a8mat=3ZDQ7O+7YYZWI+3D3Q+6EER5" rel="nofollow">
                {/* @ts-ignore */}
                <img border="0" width="336" height="280" alt="" src="https://www21.a8.net/svt/bgt?aid=240825588482&wid=003&eno=01&mid=s00000015695001075000&mc=1" />
            </a>
            {/* @ts-ignore */}
            <img border="0" width="1" height="1" src="https://www14.a8.net/0.gif?a8mat=3ZDQ7O+7YYZWI+3D3Q+6EER5" alt="" />
        </div>
    );
}

export default A8Risap;
